import gql from '@/services/gql';
import query from './query';
import { IMaterial } from '../types';

const updateQuery = gql(query);

const updateResource = (
  material: any,
  resourceName: string,
) => ({
  data: (material[`${resourceName}s`] || [])
    .map((resource: any) => ({
      ...resource,
      [`${resourceName}_id`]: resource[resourceName].id,
      // remove linked record
      [resourceName]: undefined,
    }),
  ),
  on_conflict: {
    constraint: `vendor_material_pkey`,
    update_columns: [
      `${resourceName}_id`,
      'properties',
    ],
  },
});

const returnNullableFloat = (value: string|number|undefined): number|null => {
  const parsed = parseFloat(value as string);
  return isNaN(parsed) ? null : parsed;
};

export default (
  materialId: string,
  {
    material = {} as IMaterial,
    deleteVendorIds = [] as any,
    prices = [],
    priceRemoveIds = [],
  },
) => (
  updateQuery({
    material: {
      ...material,
      id: materialId,
      // lets keep the database happy
      shrinkage: returnNullableFloat(material.shrinkage),
      thickness: returnNullableFloat(material.thickness),
      weight: returnNullableFloat(material.weight),
      width: returnNullableFloat(material.width),

      vendors: updateResource(material, 'vendor'),
    },
    delete_vendor_ids: deleteVendorIds,

    // update price (view)
    prices,
    priceRemoveIds,
  })
  .then((response: any) => {
    const { affected_rows: materialResult } = response.insert_material;
    const { affected_rows: vendor } = response.delete_vendor_material;

    if (!materialResult && !vendor) {
      throw {
        code: `MATERIAL_NOT_UPDATED`,
      };
    }
    return response;
  })
);
